module.exports = __webpack_public_path__ + "static/media/Checkliste.d73a4e56.pdf";